enum DeconciliationType {
  CONCILIATION = 'CONCILIATION',
  DIVERGENT_CONCILIATION = 'DIVERGENT_CONCILIATION',
  ERP_MOVEMENT = 'ERP_MOVEMENT',
}

export default DeconciliationType;
